'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import Helmet from 'react-helmet'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _FAQ = require('./FAQ.css');

var _FAQ2 = _interopRequireDefault(_FAQ);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FAQ = (_dec = (0, _reactCssModules2.default)(_FAQ2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(FAQ, _Component);

  function FAQ(props) {
    (0, _classCallCheck3.default)(this, FAQ);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FAQ.__proto__ || (0, _getPrototypeOf2.default)(FAQ)).call(this, props));

    _this.renderTop = function () {
      return _react2.default.createElement(
        _components.Link,
        { strong: true, to: '#top' },
        'Back to Top',
        _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-up' })
      );
    };

    _this.renderQuestions = function (_faqs) {
      return _react2.default.createElement(
        'div',
        { styleName: 'questions' },
        _faqs.map(function (faq, idx) {
          var _idx = idx + 1;
          return _react2.default.createElement(
            _components.Link,
            { to: '#' + _idx, key: 'q' + idx },
            _react2.default.createElement(
              'div',
              { styleName: 'question' },
              _idx,
              '. ',
              faq.q,
              _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-down' })
            )
          );
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'another-question' },
          _react2.default.createElement(
            'span',
            null,
            'Have another Question? '
          ),
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, styleName: 'contact', to: _config2.default.links.contact },
            'Contact us',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-envelope-o' })
          )
        )
      );
    };

    _this.renderAnswers = function (_faqs) {
      return _react2.default.createElement(
        'div',
        { styleName: 'answers' },
        _faqs.map(function (faq, idx) {
          var _idx = idx + 1;
          return _react2.default.createElement(
            'div',
            { styleName: 'answer', key: 'a' + idx },
            _react2.default.createElement('div', { styleName: 'anchor', id: _idx }),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              _idx,
              '. ',
              faq.q
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              faq.a()
            ),
            _this.renderTop()
          );
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'answer' },
          _react2.default.createElement('div', { styleName: 'anchor', id: 'contact' }),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'Get in touch'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Media and General Inquiries'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'Andrew Montes, Director of Digital Strategies, As You Sow'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, styleName: 'contact',
                  to: _config2.default.links.contact },
                'Contact',
                _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-envelope-o' })
              )
            ),
            _this.renderTop()
          )
        )
      );
    };

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(FAQ, [{
    key: 'render',
    value: function render() {
      var faqTitle = 'Frequently Asked Questions';
      var sriIcon = require('../../../static/images/sri.svg');
      var faqs = [{
        q: 'What is Deforestation Free Funds?',
        a: function a() {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Deforestation Free Funds'
              ),
              ' is a search platform that enables people to find out if their money, in the form of individual investments or an employer-provided 401(k), is exposed to companies, banks, and financiers driving deforestation around the world. Deforestation Free Funds specifically looks at companies that produce, trade, consume, or finance palm oil, rubber, soy, cattle, pulp & paper and wood products \u2013 the commodities responsible for rainforest destruction.\xA0'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Deforestation Free Funds was first launched in 2016 and exclusively examined the palm oil industry \u2013 the largest industrial agricultural driver of deforestation, as well as a major cause of social conflict, human rights abuses, and the destruction of critical wildlife habitat in tropical countries. In 2019 the platform was expanded to include the other high-risk agricultural commodities \u2013 soy, cattle, rubber, timber and pulp and paper.\xA0'
            ),
            _react2.default.createElement(
              'p',
              null,
              'If it were up to you, your money wouldn\u2019t be used to finance rainforest destruction. And now it can be up to you.\xA0'
            ),
            _react2.default.createElement(
              'p',
              null,
              'But owning investments in destructive companies isn\u2019t just an environmental or moral question. As more people recognize that the global climate cannot afford more rainforest destruction, investments in destructive companies will carry increasing financial risks. For example, many consumer brands are making efforts to cancel business ties to palm oil producers that destroy forests and violate human rights. By bringing increased transparency to the producers, consumer brands and lenders within the chain of rainforest destruction, we hope to keep pushing this trend forward.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Deforestation Free Funds empowers investors to know exactly what they own, to see if their savings are invested in the industries driving deforestation and climate change up and down supply chains, to pressure fund managers to implement sustainable investment policies, and to find investment options that support a forest-friendly future.'
            )
          );
        }
      }, {
        q: 'Why "deforestation free" funds?',
        a: function a() {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'Forests capture and store CO',
              _react2.default.createElement(
                'sub',
                null,
                '2'
              ),
              ', making global deforestation a leading cause of global warming \u2013 second only to burning fossil fuels. The science is clear: if we are going to avoid the worst impacts of climate change, we need to take urgent action. This includes protecting the world\u2019s remaining forests. In turn, protecting these forests requires respecting the rights of Indigenous Peoples and traditional forest communities around the world \u2013 because the best way to protect forests is to defend the rights of the people who live there.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'About 48 football fields\u2019 worth of tropical rainforest are destroyed every minute. Tens of billions of dollars in public and private equity is invested in the production and trade of commodities that directly cause this destruction. These billions of equity dollars are invested with the primary goal of building wealth for those of us who, in global terms, are already wealthy \u2013 leading US financial firms and their institutional clients \u2013 as well as for these firms\u2019 individual clients \u2013 average Americans with their retirement savings invested through commercial outlets like ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.routes.families + '?=Vanguard', title: 'Vanguard | Deforestation Free Funds' },
                'Vanguard'
              ),
              ', ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.routes.families + '?=JPMorgan', title: 'JPMorgan | Deforestation Free Funds' },
                'JP Morgan Chase'
              ),
              ', ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.routes.families + '?=Fidelity Investments', title: 'Fidelity Investments  | Deforestation Free Funds' },
                'Fidelity'
              ),
              ', ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.routes.families + '?=SPDR State Street Global Advisors', title: 'SPDR State Street Global Advisors | Deforestation Free Funds' },
                'State Street'
              ),
              ', and ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.routes.families + '?q=BlackRock%2FiShares', title: 'BlackRock/iShares | Deforestation Free Funds' },
                'BlackRock'
              ),
              ', or through public and private pension fund managers like TIAA-CREF and CalPERS.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'By providing a window into these investments, Deforestation Free Funds hopes to catalyze the power of individual investors to bring an end to tropical rainforest destruction by focusing on agricultural commodities responsible for widespread deforestation.'
            )
          );
        }
      }, {
        q: 'Why agricultural commodities?',
        a: function a() {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'The production of commodity crops like palm oil, soy, cattle, and wood products account for over half of the globe\u2019s deforestation and as much as one quarter of all global greenhouse gas emissions. The conversion of forests into industrial-scale agricultural plantations prevents the sequestration of large amounts of carbon, destroys critical wildlife habitat, and furthers social conflict leading to human rights abuses, often including the displacement of Indigenous Peoples and local communities. These harmful realities inherent to industrial plantation agriculture also constitute significant financial material risks to investors and shareholders alike.'
            )
          );
        }
      }, {
        q: 'Are all companies linked to agricultural commodities bad?',
        a: function a() {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'It is fair to say that industrial agricultural production, whether for palm oil, paper/pulp, timber, rubber, cattle, or soy, often relies on destructive and exploitative practices. But not all producers are guilty of the same level of abuses, not all consumer brands are directly linked to the worst tropical deforestation, and not all banks that lend to agricultural commodity companies are equally guilty. However, all of them are at risk of driving rainforest destruction. If companies that may have strong policies and practices to prevent deforestation must be consistently monitored and pressured to implement best practices. This pressure comes through shareholder engagement, through public campaigning, through government regulation and law enforcement, and, broadly speaking, by being held to a higher public standard.\xA0'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Many of the companies screened on Deforestation Free Funds are members of industry sustainability bodies that propose to drive sustainable business practices - but these bodies have proven insufficient to address the scale and nature of the problems. There are some good small companies out there, and there are some very large companies that are authentically trying to drive positive change - and our belief is that by shining a light on the financing of deforestation by industrial agricultural companies, we will further enable the changes that need to happen.'
            )
          );
        }
      }, {
        q: 'Is the production of all agricultural commodities unsustainable?',
        a: function a() {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'The industrial scale production of agricultural commodities is simply unsustainable. All of the industries screened on Deforestation Free Funds require vast areas of land, usually in places better suited to tropical forests or mixed use by local communities. The tension between corporate enterprises and local communities, and as well as the needs of ecosystems themselves, make it so that environmental destruction, illegal land grabbing, corruption, and human rights abuses have become inherent to the business models of many companies that produce and sell palm oil, soy, cattle, timber and pulp and paper. '
            )
          );
        }
      }, {
        q: 'Aren’t some companies making improvements?',
        a: function a() {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'Due to pressure from environmental and human rights organizations and scrutiny from investors and consumers, hundreds of companies have made commitments to eliminate deforestation from their operations. In 2010, the Consumer Goods Forum \u2013 a network of over 400 retail companies \u2013 committed to ending deforestation in their supply chains. In 2014, additional companies pledged to end deforestation as part of the New York Declaration on Forests. Unfortunately, the majority of these companies will fail to meet their goal of Zero Deforestation by 2020. So, even if they mean well \u2013 they need our help. (And if they don\u2019t mean well, they ',
              _react2.default.createElement(
                'em',
                null,
                'really'
              ),
              ' need our help.)'
            ),
            _react2.default.createElement(
              'p',
              null,
              'To better understand the complex landscape of company commitments to deforestation-free supply chains here are some resources:'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                'From the Zoological Society of London (ZSL), ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: _config2.default.links.zoolondon, title: 'SPOTT \u2013 Sustainability Policy Transparency Toolkit' },
                  'SPOTT \u2013 Sustainability Policy Transparency Toolkit'
                ),
                ' \u2013 is a free, online platform supporting sustainable commodity production and trade. SPOTT assesses commodity producers and traders on the public disclosure of their policies, operations and commitments related to environmental, social and governance (ESG) issues. SPOTT scores tropical forestry and palm oil companies annually against over 100 sector-specific indicators to benchmark their progress over time.'
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: _config2.default.links.forest500, title: 'Forest 500' },
                  'Forest 500'
                ),
                ' identifies and ranks the most influential companies and financial institutions in forest risk commodity supply chains as we shift to a deforestation-free economy. By objectively identifying and ranking these 500 powerbrokers on an annual basis, the Forest 500 holds the companies and financial institutions accountable for their actions.'
              ),
              _react2.default.createElement(
                'li',
                null,
                'From Forest Trends, the ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: _config2.default.links.supplychange, title: 'SupplyChange.org' },
                  'Supply Change Initiative'
                ),
                ' is a resource for businesses, investors, governments, and the civil society organizations that support and hold them accountable; providing information on the extent and value of commitment-driven commodity production and demand.'
              )
            )
          );
        }
      }, {
        q: 'Where does the “Deforestation Grade" come from that I see when I search a fund?',
        a: function a() {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'Deforestation and degradation of vast swaths of land for commodities such as palm oil, pulp and paper, cattle, soy, timber and rubber is responsible for almost one quarter of all global greenhouse gas emissions and for unprecedented species extinction.\xA0'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Our website screens for these three types of companies - producers, banks and lenders, and major consumer brands - offering visibility into the portfolio\u2019s exposure to each category.',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: "#9", title: '9. ' + faqs[8].q },
                '\xA0See the list below for the specific companies we screen for.'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'Based on whether a fund has direct stock investments in these companies, we assign one of six grades. Only funds that own stocks are scored - bond funds and other asset classes are excluded.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'grade-bullet' },
              _react2.default.createElement(_components.Grade, { grade: 1, large: true }),
              _react2.default.createElement(
                'div',
                { styleName: 'grade-bullet-copy' },
                _react2.default.createElement(
                  'p',
                  null,
                  'No holdings flagged for our deforestation screens: Assigned a grade of A.'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'grade-bullet' },
              _react2.default.createElement(_components.Grade, { grade: 2, large: true }),
              _react2.default.createElement(
                'div',
                { styleName: 'grade-bullet-copy' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Fund is invested in deforestation-risk banks and lenders and/or major consumer brands, but no holdings flagged for our deforestation-risk agricultural commodity producer/trader screen: Assigned a grade of B.'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'grade-bullet' },
              _react2.default.createElement(_components.Grade, { grade: 3, large: true }),
              _react2.default.createElement(
                'div',
                { styleName: 'grade-bullet-copy' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Fund is invested in deforestation-risk agricultural commodity producer/traders, below the threshold of 0.5%: Assigned a grade of C.'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'grade-bullet' },
              _react2.default.createElement(_components.Grade, { grade: 4, large: true }),
              _react2.default.createElement(
                'div',
                { styleName: 'grade-bullet-copy' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Fund is invested in deforestation-risk agricultural commodity producer/traders, above the threshold of 0.5% and below 1.5%: Assigned a grade of D.'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'grade-bullet' },
              _react2.default.createElement(_components.Grade, { grade: 5, large: true }),
              _react2.default.createElement(
                'div',
                { styleName: 'grade-bullet-copy' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Fund is invested in deforestation-risk agricultural commodity producer/traders, above the threshold of 1.5%: Assigned a grade of F.'
                )
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'These thresholds reflect the distribution of results across funds, placing an approximately equal number of funds from the analysis universe in the C, D, and F grade ranges.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'If a fund owns some of the companies we screen for, but has a proven track record of engaging the companies it owns by taking actions such as filing shareholder resolutions on deforestation or similar environmental issues, it earns a special acknowledgement as a \u201Cknown sustainability engager\u201D, instead of a letter grade.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'grade-bullet' },
              _react2.default.createElement(_components.Grade, { grade: 1.5, large: true }),
              _react2.default.createElement(
                'div',
                { styleName: 'grade-bullet-copy' },
                _react2.default.createElement(
                  'p',
                  null,
                  '\u201CKnown sustainability engager\u201D grade. Fund is offered by an asset manager that frequently engages companies it invests in to push for better behavior using the shareholder resolution process.'
                )
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.routes.faq + '#8', title: 'More about how fund managers engage companies on deforestation' },
                ' Read more about how fund managers engage companies on deforestation.'
              )
            )
          );
        }
      }, {
        q: 'What are funds with sustainability mandates? What about funds that engage the companies they own to push for better behavior?',
        a: function a() {
          var sriIcon = require('../../../static/images/sri.png');
          var ussifLogo = require('../../../static/images/ussif-icon.png');
          var iconEngage = require('../../../static/images/icn-engagement-shield.svg');
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Funds with sustainability mandates'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'Funds with sustainability mandates make investment decisions based on issues like environmental responsibility, human rights, or religious views. A sustainability-mandated fund may take a proactive stance by selectively investing in, for example, environmentally-friendly companies, or firms with good employee relations. They may also avoid investing in companies involved in promoting alcohol, tobacco, or gambling, or in the defense industry.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'If you see this symbol, it means that fund has a sustainability mandate:'
            ),
            _react2.default.createElement('img', {
              styleName: 'sri',
              src: sriIcon,
              alt: 'Sustainability mandate'
            }),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'The Forum for Sustainable and Responsible Investment'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.links.ussif, title: 'The Forum for Sustainable and Responsible Investment - US-SIF' },
                'The Forum for Sustainable and Responsible Investment'
              ),
              ' (known as US-SIF) is a group advancing sustainable, responsible, and impact investing. Asset managers who are members of US-SIF often have policies to exclude or restrict investments in companies with environmental or social risk.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'If you see this symbol, it means that fund is a member of US-SIF:'
            ),
            _react2.default.createElement('img', {
              styleName: 'ussif',
              src: ussifLogo,
              alt: 'Member of The Forum for Sustainable and Responsible Investment'
            }),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Sustainability engagement'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'Some sustainability-mandated funds go further, actively engaging the companies they own. Indeed, efforts by sustainability-focused investors whose funds are found on this site have been crucial to driving positive change in the palm oil sector. A number of fund families are ',
              _react2.default.createElement(
                'strong',
                null,
                'known sustainability engagers'
              ),
              ', and have taken actions such as filing ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.links.aysvote, title: 'Vote Your Shares | As You Sow' },
                'shareholder resolutions'
              ),
              ' asking for policy changes. Those families deserve special acknowledgement - often, they\u2019re using their investments to make sure they have a voice at the table to call for real improvements in company behavior. We used ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.links.ceres, title: 'Ceres Shareholder Resolution Database' },
                'data collected by Ceres'
              ),
              ' to identify fund families that have filed shareholder resolutions on deforestation, climate change, or other environmental issues. If a fund owns companies we screen for but the family is a known filer of deforestation or environmental-related shareholder resolutions, it earns a special engagement score. ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: '#7', title: '6.' + faqs[6] + '| FAQs | Deforestation Free Funds' },
                'Read more about our deforestation grades.'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'If you see this symbol, it means that fund is a known sustainability engager:'
            ),
            _react2.default.createElement(_components.Grade, { grade: 1.5, large: true }),
            _react2.default.createElement('br', null)
          );
        }
      }, {
        q: 'What companies do you look for when funds are screened?',
        a: function a() {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'Three screens are applied to each fund \u2013 a list of agricultural commodity producers, a list of banks and lenders that finance those producers, and a list of major consumer brands that use processed materials in their products.'
            ),
            _react2.default.createElement(_components.ScreenedCompanies, null)
          );
        }
      }, {
        q: "Why do you emphasize 401(k)'s? Does the tool work for other types of investment vehicles?",
        a: function a() {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'For many of us, the majority of our investments are in 401(k) plans offered by our employers. 401(k)s invest mostly through mutual funds. But those funds can invest in a wide array of securities, and it\u2019s not always easy for investors to investigate what\u2019s inside the funds they own. You can spend hours poring over mutual fund prospectuses, and still not fully grasp everything your 401(k) is invested in. Your retirement money may be invested in economically and morally risky companies.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'But regardless of how your money is invested\u2013whether through a 401(k), a traditional or Roth IRA, a pension fund or other vehicle, if you hold mutual funds or exchange-traded funds (ETFs), we can help you analyze them for deforestation-risk holdings.'
            )
          );
        }
      }, {
        q: 'What are you asking for people to do?',
        a: function a() {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'The climate crisis is perhaps the greatest threat that humanity has ever faced. While governments have a responsibility\xA0to adopt and enforce laws oriented towards limiting global warming, we will never avert catastrophic outcomes without the active participation (and drastic reform) of the financial sector. The main use of Deforestation Free Funds is to\xA0encourage people to examine their investments in order to then pressure fund managers to develop policies and practices that eliminate deforestation, land grabbing, and human rights violations.\xA0'
            ),
            _react2.default.createElement(
              'p',
              null,
              'One way to drive change through the financial sector is through ',
              _react2.default.createElement(
                'em',
                null,
                'divestment'
              ),
              ' \u2013 taking our money out of bad industries. The fossil fuel and private prison divestment movements have provided powerful examples of this. These movements are right to demand that institutions completely divest from fossil fuels and private prisons: the private prison industry causes only harm for society and should not exist, and the fossil fuel industry is driving us to the brink of planetary destruction and needs to be phased out in favor of a just transition to clean, renewable energy sources.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The alternative to divestment is \u201Cengagement\u201D \u2013 meaning, pressuring investment firms to engage with the companies they own through shareholder voting and/or direct dialogue, in order to improve their practices. Like divestment, strong shareholder engagement can be a very powerful tool for change, especially in sectors like agriculture, where there is a wide range of practices companies can adopt to work with nature and local communities, rather than against them.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'If investor engagement can get deforestation-risk companies to stamp out destructive practices, then we are all for engagement and we ask you to support this pathway. But some investors will never engage for real change \u2013 and some companies will never really change. When investors fail to engage and companies fail to improve their practices divestment becomes necessary.'
            )
          );
        }
      }, {
        q: 'Who is Friends of the Earth?',
        a: function a() {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'Friends of the Earth-United States is one of 75 national ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.links.foeabout, title: 'About | Friends of the Earth' },
                'member groups of Friends of the Earth International'
              ),
              ', a global network representing more than two million activists in 73 different countries. In our efforts to address the challenges facing our planet, we push for the transformations that are needed, not merely the ones that are politically easy. In our efforts to halt tropical deforestation, we believe we need changes in national policies and practices in both producer and consumer countries \u2013 but we also believe that both institutional and individual investors have a role to play in reducing harm and driving positive change.'
            )
          );
        }
      }, {
        q: 'Who is As You Sow?',
        a: function a() {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.links.aysabout },
                'As You Sow'
              ),
              ' promotes environmental and social corporate responsibility through shareholder advocacy, coalition building, innovative legal strategies, and online financial transparency tools. We are the nation\u2019s leading non-profit organization practicing direct shareholder engagement on environmental, social, and governance issues. Founded in 1992, As You Sow believes that corporations must be willing participants in solutions to most of today\u2019s pressing issues; and we believe that shareholders are the single most powerful force for motivating that participation. We use that power to protect health and the environment and to create positive, lasting change in corporate behavior for the long term benefit of humanity.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'In September 2015, we launched ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.links.fff, title: 'Fossil Free Funds | Invest Your Values | As You Sow' },
                'Fossil Free Funds'
              ),
              ', a search platform that enables people to find out if their money, in the form of individual investments or an employer-provided 401(k), is being used to extract and consume fossil fuels. Since then, our ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.links.aysinvest, title: 'Invest Your Values | As You Sow' },
                'Invest Your Values program'
              ),
              ' has grown to empower investors to know exactly what they own, and to find investment options that support their values. In addition to Deforestation Free Funds and Fossil Free Funds, we\u2019ve built ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.links.gef, title: 'Gender Equality Funds | Invest Your Values | As You Sow' },
                'Gender Equality Funds'
              ),
              ', ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.links.wff, title: 'Weapon Free Funds | Invest Your Values | As You Sow' },
                'Weapon Free Funds'
              ),
              ', ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.links.tff, title: 'Tobacco Free Funds | Invest Your Values | As You Sow' },
                'Tobacco Free Funds'
              ),
              ', and ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.links.gff, title: 'Gun Free Funds | Invest Your Values | As You Sow' },
                'Gun Free Funds'
              ),
              '.'
            )
          );
        }
      }];
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _container2.default.helmet(faqTitle),
          _react2.default.createElement(
            'div',
            { styleName: 'faq' },
            _react2.default.createElement(
              'div',
              { styleName: 'faq-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'title' },
                faqTitle
              ),
              this.renderQuestions(faqs),
              this.renderAnswers(faqs)
            )
          )
        )
      );
    }
  }]);
  return FAQ;
}(_react.Component)) || _class);
exports.default = FAQ;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/FAQ/FAQ.js
// module id = 1318
// module chunks = 0